import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/cpjs_bg.jpg';
import _imports_1 from '@/assets/img/公司产品.png';
import _imports_2 from '@/assets/img/pro-top.png';
import _imports_3 from '@/assets/img/wz.png';
import _imports_4 from '@/assets/img/game.png';
const _withScopeId = n => (_pushScopeId("data-v-4caeb6c1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-4caeb6c1><img src=\"" + _imports_0 + "\" alt=\"\" data-v-4caeb6c1></div><div class=\"company_jj\" data-v-4caeb6c1><img src=\"" + _imports_1 + "\" style=\"width:15%;\" alt=\"\" data-v-4caeb6c1><div class=\"top-box\" data-v-4caeb6c1><img src=\"" + _imports_2 + "\" alt=\"\" data-v-4caeb6c1><img class=\"wz\" src=\"" + _imports_3 + "\" alt=\"\" data-v-4caeb6c1></div><div class=\"pic\" data-v-4caeb6c1><div class=\"content\" data-v-4caeb6c1><h2 data-v-4caeb6c1>星星萌萌消</h2><p data-v-4caeb6c1> 火遍全国的超人气消除游戏，它来了！游戏的核心玩法是消除，玩家收集三个一样图案的纸牌到下面的槽位中，即可完成消除操作。游戏最终的目标就是通过不断的消除操作，最终收集、清除所有纸牌。我们在此基础上进行了更多游戏美术改进，增加了星星篇、风景建筑篇、春节篇、故宫文物篇、饮料篇等多个场景，给用户更多选择。 </p><a href=\"https://dou-sucai.oss-cn-hangzhou.aliyuncs.com/xxmmx_oppo_12.apk?OSSAccessKeyId=LTAI5tQxtzXyHx72YYgG6Sca&amp;Expires=2128991532&amp;Signature=lCjGDwNKIctZ4b%2BnuvhOiKgEDLU%3D\" data-v-4caeb6c1>立即下载&gt;&gt;</a></div><img src=\"" + _imports_4 + "\" alt=\"\" data-v-4caeb6c1></div></div>", 2);
const _hoisted_4 = [_hoisted_2];
import { reactive, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({});
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
    };
  }
});